export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/underLine.eb36d972.svg","height":15,"width":77,"blurWidth":0,"blurHeight":0};